<script lang="ts">
  import { page } from '$app/stores';
  import { selectedRace } from '$lib/stores';
  import type { Race } from '$types/races';
  import { raceFilters } from '$utils/filters';
  import { getRaceLink, selectedRaceId } from '$utils/navigation';
  import { isRaceClosed } from '$utils/race';
  import { calculateTimeToJump, currentTime } from '$utils/time';
  import { sidebarOpen } from '$utils/ui';
  import { scrollToActiveRace } from './RaceList.svelte';

  $: ({ streamed } = $page.data);

  export let races: Race[];

  let hovered = false;

  // calculate the next to jump race
  $: nextToJump =
    races
      ?.filter(
        // add 60 seconds to the start time as a buffer, so if the race is not yet closed, it will be the next to jump
        (race) =>
          race.startTime &&
          race.startTime.getTime() + 1000 * 60 > $currentTime.getTime()
      )
      ?.reduce((a, b) => {
        if (isRaceClosed(a) && !isRaceClosed(b)) return b;
        if (isRaceClosed(b) && !isRaceClosed(a)) return a;
        if (!a?.startTime) return b;
        if (!b?.startTime) return a;
        if (!$currentTime) return a;

        return Math.abs(a.startTime.valueOf() - $currentTime.valueOf()) <
          Math.abs(b.startTime.valueOf() - $currentTime.valueOf())
          ? a
          : b;
      }, {} as Race) ?? null;

  $: ttj = calculateTimeToJump(nextToJump.startTime, $currentTime) ?? '';

  async function scrollIntoView() {
    $scrollToActiveRace();
    if (nextToJump.id === $selectedRaceId) return;
    if (streamed) streamed.raceData = undefined;
    selectedRaceId.set(nextToJump.id);
    sidebarOpen.set(false);
  }

  async function clearFilter() {
    raceFilters.clearFilters();
  }
</script>

{#if nextToJump?.id}
  <a
    href={getRaceLink(nextToJump)}
    on:click={scrollIntoView}
    on:keypress={scrollIntoView}
    class="
        shadow-lg-ring-1 sticky
                m-2
                 flex
                items-center gap-6 rounded-md bg-slate-800 px-4
                py-3
                text-xs font-semibold
                leading-none tracking-widest text-white shadow-lg ring-1 ring-black/5
                transition
                hover:bg-gray-700
                focus:border-gray-900
                focus:outline-none focus:ring focus:ring-gray-300 active:bg-gray-900
                disabled:opacity-25
                "
  >
    <div class="flex w-full flex-row">
      <span class="flex flex-1 pr-2 uppercase"
        >R{nextToJump.number} {nextToJump.meeting?.track}</span
      >
      <span
        class="max-w-md justify-end pl-2 font-light text-indigo-200 transition duration-200 group-hover:text-gray-100"
        >{ttj}</span
      >
    </div>
  </a>
{:else}
  <button
    on:mouseover={() => (hovered = true)}
    on:mouseout={() => (hovered = false)}
    on:focus={() => (hovered = true)}
    on:blur={() => (hovered = false)}
    on:click={clearFilter}
    on:keypress={clearFilter}
    class="shadow-lg-ring-1 sticky m-2 flex cursor-pointer items-center gap-6 rounded-md bg-slate-800 px-4 py-3 text-xs font-semibold leading-none tracking-widest text-white shadow-lg ring-1 ring-black/5 transition hover:bg-gray-700 focus:border-gray-900 focus:outline-none focus:ring focus:ring-gray-300 active:bg-gray-900 disabled:opacity-25"
  >
    {#if hovered}
      <span class="flex grow pr-2 uppercase">Clear Filters</span>
    {:else}
      <span class="flex grow pr-2 uppercase">No Open Races In Filter</span>
    {/if}
  </button>
{/if}
